<template>
  <div class="chart-box" ref="chartBox" :style="getChartStyle">
    <v-chart
      class="chart"
      v-if="showChart && !isEmptyData"
      :option="getOption"
      :init-options="getInitOptions"
      ref="radar"
      theme="ovilia-green"
      @click="dispatchEventCallback('click', $event)"
      @dblclick="dispatchEventCallback('dblclick', $event)"
      @mouseover="dispatchEventCallback('mouseover', $event)"
      @mouseout="dispatchEventCallback('mouseout', $event)"
      @mouseup="dispatchEventCallback('mouseup', $event)"
      @mousedown="dispatchEventCallback('mousedown', $event)"
      @touchstart="dispatchEventCallback('touchstart', $event)"
      @touchend="dispatchEventCallback('touchend', $event)"
      autoresize
    />
    <!-- 空数据 -->
    <div class="null-data" v-if="isEmptyData">
      <img src="../../../../assets/images/img-null-data-light.png" alt="" />
      <p v-if="errorCode" class="textColor">{{ errorCode }}报错</p>
      <p v-else>暂无数据</p>
    </div>
  </div>
</template>

<script>
import parentMixin from "components/bigScreenComponents/base"
import plugins from "./plugin"
import handleChartData from "utils/updateData/chart/handleChartData.js"
import { hasProperty } from "utils"
export default {
  mixins: [parentMixin, plugins, handleChartData],
  data() {
    return {
      eventCallbackList: {
        click: [],
        dblclick: [],
        mouseover: [],
        mouseout: [],
        mouseup: [],
        mousedown: [],
        touchstart: [],
        touchend: []
      }
    }
  },
  name: "cxRadar",
  watch: {
    "options.chartOption.series": function (newVal, oldVal) {
      if (newVal[0].animationDuration !== oldVal[0].animationDuration) {
        this.initOption = this.options.initOptions
      }
      if(this.options.numberCount){
        this.checkFormatterValue()
      }
    },
    getDragStatus(newVal, oldVal) {
      this.getDragStatusHandle(newVal, oldVal, "radar")
      this.formatterFunc()
    },
    refreshedChart(newVal) {
      if (newVal) {
        this.$refs.radar?.setOption(this.getOption)
      } else {
        this.$refs.radar?.clear()
      }
    }
  },
  mounted() {
    this.refreshFunc()
    if (this.options.chartOption.radar.axisName.showMaxLabel) {
      this.formatterFunc()
    }
    this.checkFormatterValue()
  },
  destroyed() {
    clearInterval(this.reloadTimer)
    this.reloadTimer = null
  },
  methods: {
    formatterFunc() {
      let chartOpt = this.options.chartOption.radar.axisName
      if (chartOpt.showMaxLabel) {
        chartOpt.rich = {
          a: {
            fontFamily: chartOpt.fontFamily,
            color: this.$parseColor(chartOpt.color),
            fontWeight: chartOpt.fontWeight,
            fontSize: chartOpt.fontSize
          },
          b: {
            fontFamily: chartOpt.maxLabelFontFamily,
            color: this.$parseColor(chartOpt.maxLabelFontColor),
            fontWeight: chartOpt.maxLabelFontWeight,
            fontSize: chartOpt.maxLabelFontSize,
            padding: [10, 0]
          }
        }
        let unitStr = chartOpt.maxLabelUnit ? chartOpt.maxLabelUnit : ""
        chartOpt.formatter = (value, indicator) => {
          return ["{a|" + value + "}", "{b|" + indicator.max + " " + unitStr + "}"].join("\n")
        }
      }
    }
  }
}
</script>

<style scoped>
.chart {
  height: 100%;
}
</style>
